var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosedEyesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3418_3441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.37204 3.95421C4.46269 3.05382 3.64214 2.24164 2.82159 1.42946C2.4697 1.07995 2.13753 0.690505 2.60289 0.229493C3.07647 -0.238177 3.43659 0.142949 3.78027 0.490788C8.54405 5.31727 13.3078 10.1421 18.0716 14.9669C18.1686 15.0651 18.2624 15.1666 18.3577 15.2648C18.6751 15.596 18.8708 15.9588 18.4597 16.3366C18.0601 16.7044 17.7049 16.4897 17.3876 16.1669C16.6739 15.4396 15.9783 14.689 15.2301 13.9983C15.0476 13.8302 14.6168 13.712 14.4244 13.8135C10.4466 15.9039 6.83225 15.0401 3.48428 12.4006C2.39076 11.5384 1.46333 10.4616 0.465189 9.47471C0.0327159 9.04698 0.0195609 8.58097 0.471767 8.17655C1.92047 6.87839 3.38562 5.59688 4.84748 4.3137C4.96587 4.20885 5.10893 4.13229 5.37039 3.95421H5.37204ZM12.1453 10.9043C10.4614 12.061 9.14261 12.1276 8.02772 10.9926C7.5936 10.5498 7.28281 9.89744 7.11837 9.28664C6.84705 8.28306 7.36174 7.42595 7.95372 6.65204C7.39134 6.08618 6.87171 5.56192 6.35702 5.04266C4.77512 5.70339 2.30526 7.77212 1.75439 8.8922C5.24542 13.0646 9.94836 15.0768 13.7272 12.5337C13.2141 12.0061 12.6994 11.4752 12.1469 10.906L12.1453 10.9043ZM8.93871 7.66727C8.23984 8.55934 8.27273 9.46638 8.97817 10.0472C9.68361 10.6297 10.4515 10.5598 11.083 9.87247C10.3808 9.15017 9.68033 8.42952 8.93871 7.66727Z",
    fill: "url(#paint0_linear_3418_3441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 8.85385C16.2508 6.53048 14.0572 4.60322 10.9937 4.09727C10.331 3.98743 9.63378 4.06066 8.95465 4.09894C8.51231 4.1239 8.0897 4.15053 7.99104 3.60464C7.88416 3.0188 8.27059 2.86236 8.76226 2.77415C10.6204 2.44295 12.3536 2.86902 14.0128 3.66955C16.2015 4.72471 17.979 6.3058 19.533 8.16982C19.9211 8.63417 19.9539 9.04192 19.5248 9.4763C18.7322 10.2785 17.9741 11.119 17.1305 11.8596C16.9184 12.046 16.31 12.066 16.0995 11.8929C15.6868 11.5534 15.986 11.1639 16.3133 10.856C16.9891 10.2202 17.6551 9.57283 18.4033 8.85385Z",
    fill: "url(#paint1_linear_3418_3441)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_3441",
    x1: 9.41477,
    y1: 0.012085,
    x2: 9.41477,
    y2: 16.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_3441",
    x1: 13.9043,
    y1: 2.66113,
    x2: 13.9043,
    y2: 12.0118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3418_3441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6948,
    height: 16.5182,
    fill: "white",
    transform: "translate(0.13916 0.0113525)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEyesIcon);
export default __webpack_public_path__ + "static/media/closed-eyes-icon.9b5cb43d938e1e8669a5ea1165e956a6.svg";
export { ForwardRef as ReactComponent };